module.exports = __webpack_public_path__ + "static/media/task.efbc9ecf.png";